const Statistics = Mach.requireModule('Statistics');
let CID = 'c_waimai_c_overseas_ftj7f1qa'; //默认使用提单页的cid， 可通过orderLx.setCid修改成对应页的cid

interface Value {
  [key: string]: any;
}

const mv = (bid: string, val: Value = {}) => {
  Statistics.view(CID, bid, val);
};

const mc = (bid: string, val: Value = {}) => {
  Statistics.click(CID, bid, val);
};

const orderLx = {
  setCid(cid) {
    CID = cid;
  },

  // 订单信息 曝光
  orderInfoMv(val) {
    mv('b_waimai_c_overseas_32hd731q_mv', val);
  },

  //查看更多商品，曝光
  moreProductInfoMv(val) {
    mv('b_sailor_c_cmwsao03_mv', val);
  },

  //查看更多商品，点击
  moreProductInfoMc(val) {
    mc('b_sailor_c_cmwsao03_mc', val);
  },

  //查看门店信息，点击
  shopInfoAreaMc(val) {
    mc('b_sailor_c_6cfutfcd_mc', val);
  },

  //查看更多规格按钮
  attrArrowMc(val) {
    mc('b_waimai_c_overseas_qlsd8joh_mc', val);
  },

  //订单信息-商品卡片 曝光
  orderFoodItemMv(val) {
    mv('b_waimai_c_overseas_yc5dvn4e_mv', val);
  },

  //订单信息-计费区域  曝光
  promotionMv(val) {
    mv('b_waimai_c_overseas_spkgstad_mv', val);
  },

  //订单信息-计费区域-订单最低消费补差价  曝光
  priceSpreadMv(val) {
    mv('b_waimai_c_overseas_j35yhn8y_mv', val);
  },

  //订单信息-计费区域-小计金额  曝光
  productTotalMv(val) {
    mv('b_waimai_c_overseas_tr1j6t8d_mv', val);
  },

  //订单信息-计费区域-小计金额规则 点击
  productTotalRuleMc(val) {
    mc('b_sailor_c_uonzguff_mc', val);
  },

  // 订单信息-计费区域-小计金额规则 曝光
  productTotalRuleMv(val) {
    mv('b_sailor_c_uonzguff_mv', val);
  },

  //订单信息-计费区域-优惠使用条  曝光  2 有可用券，但用户未使用；3 无可用券 4 未填写地址 5 用户选择券
  discountMv(val) {
    mv('b_waimai_c_overseas_qyk4pp19_mv', val);
  },

  //订单信息-计费区域-优惠使用条  点击
  discountMc(val) {
    mc('b_waimai_c_overseas_qyk4pp19_mc', val);
  },

  //订单信息-计费区域--配送费  曝光
  deliveryFeeMv(val) {
    mv('b_waimai_c_overseas_p2cr41hf_mv', val);
  },
  //订单信息-计费区域--平台费规则  点击
  platformFeeRuleMc(val) {
    mc('b_waimai_c_overseas_owqz9mwi_mc', val);
  },
  //订单信息-计费区域--一口价平台费规则  点击
  fixedPlatformFeeRuleMc() {
    mc('b_sailor_c_qorhe623_mc');
  },
  //订单信息-计费区域--一口价  曝光
  fixedPricedMv(val) {
    mv('b_sailor_c_tdtq6upo_mv', val);
  },
  //订单信息-计费区域--一口价  点击
  fixedPricedMc(val) {
    mc('b_sailor_c_tdtq6upo_mc', val);
  },
  //订单信息-优惠规则 点击，无此点击
  discountRuleMc() {
    mc('b_waimai_c_overseas_l9i30x5q_mc');
  },
  //订单信息-discount入口 曝光
  discountInfoMv(val) {
    mv('b_sailor_c_loh3dxtp_mv', val);
  },
  //订单信息-discount入口 点击
  discountInfoMc(val) {
    mc('b_sailor_c_loh3dxtp_mc', val);
  },
  // 一口价弹窗曝光
  fixedDialogMv(val) {
    mv('b_sailor_c_yys4b1du_mv', val);
  },
  // 一口价弹窗内的平台说明
  fixedPlatformDialogMv(val) {
    mv('b_sailor_c_4dnyp1l4_mv', val);
  },
  // 一口价弹窗内的平台说明
  fixedPlatformDialogMc(val) {
    mc('b_sailor_c_4dnyp1l4_mc', val);
  },
  // 一口价弹窗内gotit和蒙层点击
  fixedBottomDialogMc(val) {
    mc('b_sailor_c_3q5u27be_mc', val);
  },
  // 配送费说明icon 点击
  deliveryDescIconMc(val) {
    mc('b_sailor_c_glyo51qo_mc', val);
  },
  // 点击叹号展示底部弹窗
  bottomDialogMv(val) {
    mv('b_sailor_c_dhk3xu3h_mv', val);
  },
  // 点击叹号展示底部弹窗
  bottomDialogMc(val) {
    mc('b_sailor_c_dhk3xu3h_mc', val);
  },
  showDeliveryFreeMv(val) {
  // 减配送费： 4
  // 免配送费：21
    mv('b_sailor_c_pyo5nzh1_mv', { delivery_activity_id: val });
  },
  // 发票入口曝光
  invoiceMv(val) {
    mv('b_sailor_c_y7lrxle0_mv', val);
  },
  // 发票入口点击
  invoiceMc(val) {
    mc('b_sailor_c_y7lrxle0_mc', val);
  },
};

export default orderLx;
